(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('inbox', {
            parent: 'app',
            url: '/inbox',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.inbox'
            },
            views: {
                'content@': {
                    templateUrl: 'app/inbox/inbox.html',
                    controller: 'InboxController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('inbox');
                    return $translate.refresh();
                }],
                party: ['$stateParams', 'AppPartySvc', function($stateParams, AppPartySvc) {
                    return AppPartySvc.get().$promise;
                }]
            }
        });
    }
})();



